// Injects a small print stylesheet the first time it's mounted.
// Everything with class="print-only" is hidden on screen and shown in print;
// everything with class="no-print" is hidden in print.
import { useEffect } from "react";
let injected = false;
export default function PrintStyles() {
    useEffect(() => {
        if (injected)
            return;
        injected = true;
        const s = document.createElement("style");
        s.textContent = `
      @media print {
        .no-print { display: none !important; }
        header, footer, aside { display: none !important; }
        main, body, html { background: white !important; color: black !important; }
        .card { box-shadow: none !important; border-color: #ccc !important; background: white !important; }
        table { font-size: 11px !important; }
        th { background: #eee !important; color: black !important; }
        .grade-badge { border: 1px solid #333 !important; color: black !important; background: white !important; }
        @page { margin: 12mm; }
      }
      .print-only { display: none; }
      @media print { .print-only { display: block !important; } }
    `;
        document.head.appendChild(s);
    }, []);
    return null;
}
